interface IconCalendarProps {
  active?: boolean;
}
export const IconCalendar = ({ active }: IconCalendarProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.75 2.5V4.5M17.25 2.5V4.5M3 18.75V7C3 5.75736 4.00736 4.5 5.25 4.5H19C20.2426 4.5 21 5.75736 21 7V18.75M3 18.75C3 19.9926 4.00736 21 5.25 21H18.75C19.9926 21 21 19.9926 21 18.75M3 18.75V11.25C3 10.0074 4.00736 9 5.25 9H18.75C19.9926 9 21 10.0074 21 11.25V18.75"
        stroke={active ? "#FF9934" : "#999999"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.375 12.875C11.375 12.3918 11.7668 12 12.25 12C12.7332 12 13.125 12.3918 13.125 12.875C13.125 13.3582 12.7332 13.75 12.25 13.75C11.7668 13.75 11.375 13.3582 11.375 12.875ZM8.25 16.5C7.76675 16.5 7.375 16.8918 7.375 17.375C7.375 17.8582 7.76675 18.25 8.25 18.25C8.73325 18.25 9.125 17.8582 9.125 17.375C9.125 16.8918 8.73325 16.5 8.25 16.5ZM12.25 16.5C11.7668 16.5 11.375 16.8918 11.375 17.375C11.375 17.8582 11.7668 18.25 12.25 18.25C12.7332 18.25 13.125 17.8582 13.125 17.375C13.125 16.8918 12.7332 16.5 12.25 16.5ZM16.25 12C15.7668 12 15.375 12.3918 15.375 12.875C15.375 13.3582 15.7668 13.75 16.25 13.75C16.7332 13.75 17.125 13.3582 17.125 12.875C17.125 12.3918 16.7332 12 16.25 12Z"
        fill={active ? "#FF9934" : "#999999"}
      />
    </svg>
  );
};
